import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Star } from 'lucide-react';
const wins = [{
  metric: '+45%',
  label: 'Monthly Volume',
  description: 'Delivered across multiple locations within 90 days through funnel rebuild + review acceleration.',
  icon: Users,
  color: 'text-blue-600',
  bg: 'bg-blue-50'
}, {
  metric: '2.5x',
  label: 'Return on Ad Spend',
  description: 'Optimized acquisition channels and retargeting automation producing consistent, profitable bookings.',
  icon: TrendingUp,
  color: 'text-[#ff8a33]',
  bg: 'bg-orange-50'
}, {
  metric: '4.9',
  label: 'Google Rating',
  description: 'Implemented automated review systems generating 200+ 5-star reviews across physical locations.',
  icon: Star,
  color: 'text-emerald-600',
  bg: 'bg-emerald-50'
}];
export function ExampleWins() {
  return <section id="wins" className="py-24 bg-white relative" data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gray-100 text-gray-600 text-xs font-semibold uppercase tracking-wider mb-6" data-id="element-73">
            Track Record
          </motion.div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-74">
            Real Results Where It Matters
          </h2>
          <p className="text-xl text-gray-600" data-id="element-75">
            Measurable outcomes that tie directly to revenue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-76">
          {wins.map((win, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-white rounded-2xl p-8 shadow-xl shadow-gray-200/50 border border-gray-100 text-center group hover:border-gray-200 transition-all" data-id="element-77">
              <div className={`w-16 h-16 mx-auto rounded-2xl ${win.bg} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-78">
                <win.icon className={`w-8 h-8 ${win.color}`} data-id="element-79" />
              </div>
              <div className={`text-5xl font-bold mb-2 ${win.color}`} data-id="element-80">
                {win.metric}
              </div>
              <div className="text-lg font-bold text-gray-900 mb-4" data-id="element-81">
                {win.label}
              </div>
              <p className="text-gray-600 leading-relaxed" data-id="element-82">{win.description}</p>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-83">
          <p className="text-sm text-gray-500 italic" data-id="element-84">
            (Results are anonymized until public case approvals.)
          </p>
        </div>
      </div>
    </section>;
}